import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import * as moment from 'moment';
import {DatePickerComponent, IDatePickerConfig, DatePickerDirective} from 'ng2-date-picker';
import {DatePickerModeEnum} from '../../models/DatePickerModeEnum';

@Component({
    selector: 'app-review-date-picker',
    templateUrl: './review-date-picker.component.html',
    styleUrls: ['./review-date-picker.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ReviewDatePickerComponent implements OnInit {
    @ViewChild('dayPicker') datePicker: DatePickerComponent;
    @ViewChild('monthPicker') monthPicker: DatePickerDirective;
    @Output()
    dateSelected: EventEmitter<moment.Moment> = new EventEmitter();
    @Input()
    datePickerMode: DatePickerModeEnum;
    DatePickerModeEnum = DatePickerModeEnum;
    monthPickerFormat = 'MMM, YYYY';
    selectedDate: any;
    displayMonth: moment.Moment | string;
    datePickerConfig: IDatePickerConfig = {
        showWeekNumbers: true,
        weekDayFormat: 'dd'
    };

    constructor() {}

    ngOnInit() {

        if (this.datePickerMode === DatePickerModeEnum.Date) {
            this.selectedDate = moment();
        } else if (this.datePickerMode === DatePickerModeEnum.Month) {
            this.displayMonth = moment().format(this.monthPickerFormat);
        }
    }

    openDatePicker() {
        this.datePicker.api.open();
    }

    openMonthPicker() {
        this.monthPicker.api.open();
    }

    onDateSelected() {
        if (this.datePickerMode === DatePickerModeEnum.Date) {
            this.dateSelected.emit(this.selectedDate);
        } else if (this.datePickerMode === DatePickerModeEnum.Month) {
            this.displayMonth = this.selectedDate;
            this.dateSelected.emit(moment(this.selectedDate, this.monthPickerFormat));
        }

    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/review-date-picker/review-date-picker.component.ts